import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
} from "antd";
import { SearchOutlined, EllipsisOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_FRIEND_PAGE,
  GET_PAGE,
  GET_USERS_LIST,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import AddGroupModal from "components/Modals/AddGroupModal";
import InvitePeopleModal from "components/Modals/InvitePeopleModal";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import { generateUUID, popupCenter } from "utils/appUtil";

let timeout: NodeJS.Timeout;

function formatUserFilterText(text) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return formatForRedis(x) + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  console.log('comp here', comp)
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

// function getFriendPageRequest(data) {
//   const obj = unwrapAsObject(data);
//   var result = {};

//   if (!obj.friendId) {
//       result.error = "Friend user ID is required";
//   } else {
//       var searchQuery = `@pageType:{friend}@pageMembers:{${connectionData.rootUserId}}@pageMembers:{${obj.friendId}}`;

//       result = {
//           responseTopic: `${connectionData.ecosystem}/connection/${connectionData.connectionId}/service/live/searchPage/reply`,
//           requestList: [
//               {
//                   topic: `${connectionData.ecosystem}/connection/${connectionData.connectionId}/service/live/searchPage`,
//                   payload: {
//                       paths: ["$"],
//                       returnPaths: ["$"],
//                       searchIndex: "beamdev:pageUpdatedAtIndex",
//                       searchQuery: searchQuery,
//                       searchOptions: "SORTBY updatedAt DESC"
//                   }
//               }
//           ]
//       }
//   }

//   return JSON.stringify(result);
// }

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

const ProjectListModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { selectedItem, userSearchPage } = useSelector(
    (state: RootState) => state.search
  );

  const { projects } = useSelector(
    (state: RootState) => state.dashboard
  );

  const { users, findUsersToPage, searchBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [groupModalOpen, setgroupModalOpen] = useState(false);
  const [inviteModalOpen, setinviteModalOpen] = useState(false);
  // const [allUsers, setAllUsers] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState<UserInfo[]>(
  const [selectedUsers, setSelectedUsers] = useState<any[]>([
    { id: localStorage.getItem("RID") },
  ]);
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();

  const findUsers = () => {
    let serviceId = "cudb-live";
    const queryId = generateUUID();
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/live/findUsersToPage`,
      wrapRequestPayload(
        {
          userId: localStorage.getItem("RID"),
          cudbServiceId: serviceId,
          mode: "cudb",
          queryId: queryId,
        },
        queryId
      )
    );
  };

  // const searchUser = (inputQueryId: string, filterText?: string) => {
  //   let serviceId = "cudb-live";
  //   var searchQuery = `@userType:{user}@serviceId:{${formatForRedis(
  //     serviceId
  //   )}}`;
  //   if (filterText && filterText.length > 2) {
  //     searchQuery += formatUserFilterText(filterText);
  //   }
  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/service/bds/searchBds`,
  //     wrapRequestPayload({
  //       pagination: { offset: 0, limit: 100 },
  //       searchIndex: "beamdev:userNameIndex",
  //       searchQuery: searchQuery,
  //       searchOptions: "SORTBY beamIds ASC",
  //       inputQueryId,
  //     })
  //   );
  // };

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    if (filterText && filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload({
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 1000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            email: "$..live.alternativeIds.email",
            phone: "$..live.alternativeIds.phone",
            profile: "$..profile",
          },
        },
        groupBy: {
          properties: ["@email", "@profile", "@phone"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      })
    );
  };

  useEffect(() => {
    
  }, []);




  const getUser = (userObj) => {
    const user = allUsers?.find((obj) => obj.id === userObj.id);
    console.log("user", user);
    return (
      <Col span={13}>
        <h5>
          {user && user.name
            ? user.name
            : userObj?.beamId && userObj?.beamId !== ""
            ? userObj?.beamId
            : `user #${userObj.id}`}
        </h5>
        <p>{user?.email ?? "-"}</p>
        <p>{user?.phone ?? "-"}</p>
      </Col>
    );
  };


  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => {}}
        onCancel={handleCancel}
        width="480px"
        className="beam-modal scrollable"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <Row className="d-flex mt-1 mb-4">
          <Col>
            <h3>Project</h3>
          </Col>
          {/* {selectedItem && selectedItem.currentUserRole === "edit" && (
            <Col>
              <Button
                className="beam-btn blue-btn cover"
                onClick={() => {
                  setgroupModalOpen(true);
                }}
              >
                Create new Group
              </Button>
            </Col>
          )} */}
        </Row>
        {/* <Row>
          <Col span={24}>
            <Input
              onChange={(e) => {
                const value: string = e.target.value;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                  // dispatch(GET_USERS_LIST(value));
                  if (findUsersToPage) {
                    aggregateUser(findUsersToPage.queryId, value);
                  }
                  // dispatch(GET_PAGE({ search: value }));
                }, 500);
              }}
              placeholder="Search"
              suffix={<SearchOutlined />}
            />
          </Col>
        </Row> */}
        <Row className="scrollable-body mt-4" ref={scrollRef}>
          <Col span={24}>
            <React.Fragment>
              {projects &&
                projects?.projects.map(
                  (project, index) => {
                    return (
                      <Row className="person-item" key={index}>
                        <Col span={14}>
                          <h5>{project.name}</h5>
                        </Col>
                        <Col span={10} className="t-right">
                          <Button
                            className="beam-btn green-btn"
                            onClick={() => {
                              popupCenter(
                                `${
                                  process.env.REACT_APP_SHARED_URI
                                }/cpc?userId=${localStorage.getItem(
                                  "RID"
                                )}&connectionId=${localStorage.getItem("CID")}&projectId=${project.id}`,
                                "First CAD",
                                window.innerWidth * 0.7,
                                window.innerHeight * 0.9
                              );
                            }}
                          >
                            Create event
                          </Button>
                        </Col>
                      </Row>
                    )
                  }
                )}
            </React.Fragment>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default ProjectListModal;
